import React from 'react';
import {View} from 'react-native';

import ListItem from '/component/base/ListItem';
import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './Loading.style';

export const Loading = () => {
  const {tt} = useTranslation('reportCardContent.client');
  return (
    <View style={styles.base}>
      <View style={styles.header}>
        <Gutter>
          <Text variant="heading">Earned Client Acquisition Bonus</Text>
        </Gutter>
      </View>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<Text>{tt('earnedOn', 'Earned on')}</Text>}
          suffix={<LoadingBox style={styles.earnedOn} />}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<Text>FQV during CAB Period</Text>}
          suffix={<LoadingBox style={styles.fqv} />}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={
            <Text>
              {tt('totalNewOrderingEntities', 'Total New Ordering Entities')}
            </Text>
          }
          suffix={<LoadingBox style={styles.entities} />}
        />
      </Gutter>
    </View>
  );
};
